import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { GestionDonneesModule } from '../gestion-donnees/gestion-donnees.module';
import { ListParcoursComponent } from './list-parcours/list-parcours.component';
import { DetailParcoursComponent } from './detail-parcours/detail-parcours.component';
import { SelectionQualificatorComponent } from './selection-qualificator/selection-qualificator.component';
import { ModuleDetailModalComponent } from './module-detail-modal/module-detail-modal.component';

@NgModule({
	declarations: [
		ListParcoursComponent,
		DetailParcoursComponent,
		SelectionQualificatorComponent,
		ModuleDetailModalComponent
	],
	imports: [SharedModule, GestionDonneesModule]
})
export class ParcoursModule {}
